import React from 'react';

const Footer = () => (
  <footer className='bg-light p-3 text-center'>
    <div class='col-lg-12 text-center'>
      <div class='copyright'>Copyright &copy; Michels MFG LLC 2017 - 2022</div>
    </div>
  </footer>
);

export default Footer;
